import React from 'react'
import Nav from './Nav';

const Header = () => {
  return (
    <header className="header">
        <img src="/Little-Lemon.jpg" alt='Little Lemon Logo'/>
        <Nav />
    </header>
  )
}

export default Header